export default class ConsequencePolicy {
    constructor(gate) {
        this.gate = gate;
    }

    browse(user, action) {
        return this.gate.allow('edit', 'action', action);
    }

    read(user, consequence, action) {
        return this.gate.allow('edit', 'action', action);
    }

    add(user, action) {
        return this.gate.allow('edit', 'action', action);
    }

    edit(user, consequence, action) {
        return this.gate.allow('edit', 'action', action);
    }

    destroy(user, consequence, action) {
        return this.gate.allow('edit', 'action', action);
    }

    restore(user, consequence, action) {
        return this.gate.allow('edit', 'action', action);
    }
}
